<template>
  <div id="tos" class="section">
    <h1 class="title">{{ $t('tos.title') }}</h1>
    <hr>
    <p v-html="$t('tos.description')"></p>
    <div class="margin-top-60px has-text-left">
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('tos.3') }}</h2>
        <p>{{ $t('tos.4') }}</p>
        <p>{{ $t('tos.5') }}</p>
        <p>{{ $t('tos.6') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('tos.7') }}</h2>
        <p>{{ $t('tos.8') }}</p>
        <p>{{ $t('tos.9') }}</p>
        <p>{{ $t('tos.10') }}</p>
        <p>{{ $t('tos.11') }}</p>
        <p>{{ $t('tos.12') }}</p>
        <p>{{ $t('tos.13') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('tos.14') }}</h2>
        <p>{{ $t('tos.15') }}</p>
        <p>{{ $t('tos.16') }}</p>
        <p>{{ $t('tos.17') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('tos.18') }}</h2>
        <p>{{ $t('tos.19') }}</p>
        <p>{{ $t('tos.20') }}</p>
        <p>{{ $t('tos.21') }}</p>
        <p>{{ $t('tos.22') }}</p>
        <p>{{ $t('tos.23') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('tos.24') }}</h2>
        <p>{{ $t('tos.25') }}</p>
        <p>{{ $t('tos.26') }}</p>
      </div>
      <div class="margin-bottom-60px">
        <h2 class="title">{{ $t('tos.27') }}</h2>
        <p>{{ $t('tos.28') }}</p>
        <p>{{ $t('tos.29') }}</p>
      </div>
      <p class="has-text-centered">{{ $t('tos.30') }}</p>
    </div>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useSeoHead } from "@/helpers/seo";

export default {
  name: 'Tos',
  created() {
    useSeoHead({
      base: '/tos',
      locale: this.$i18n.locale,
      title: `${this.$t('tos.title')} | ${appConfig[this.$i18n.locale].title}`,
      description: appConfig[this.$i18n.locale].description.top,
    })
  }
}
</script>

<style lang="scss" scoped></style>
